import { createContext } from 'react'
import { CheckoutSimulatorContextProps } from './interfaces'

export const CheckoutSimulatorContext = createContext(
  {} as CheckoutSimulatorContextProps,
)
